export const EASING_STANDARD = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
export const EASING_DECELERATING = 'cubic-bezier(0.0, 0.0, 0.2, 1)';
export const EASING_ACCELERATING = 'cubic-bezier(0.4, 0.0, 1, 1)';

export const DURATION_SMALL = '100ms';
export const DURATION_MEDIUM_EXPAND = '250ms';
export const DURATION_MEDIUM_COLLAPSE = '200ms';
export const DURATION_LARGE_EXPAND = '300ms';
export const DURATION_LARGE_COLLAPSE = '250ms';

export const COMPLEX_STANDARD = `${DURATION_LARGE_EXPAND} ${EASING_STANDARD}`;
export const COMPLEX_ACCELERATING = `${DURATION_LARGE_EXPAND} ${EASING_ACCELERATING}`;
export const COMPLEX_DECELERATING = `${DURATION_LARGE_EXPAND} ${EASING_DECELERATING}`;
